import React from 'react';
import { motion } from 'framer-motion';
import { FaServer, FaPencilRuler, FaReact, FaJs, FaHtml5, FaCss3Alt, FaVuejs } from 'react-icons/fa';
import { SiMakerbot, SiTailwindcss, SiFigma, SiCanva } from 'react-icons/si';
import logoDesignVideo from '../../assets/logos/logo-design-illustration.mp4';
import webHostingVideo from '../../assets/logos/web-hosting-illustration.mp4';
import websiteVideo from '../../assets/logos/logo-website-illustration.mp4';
import automationVideo from '../../assets/logos/logo-automation-illustration.mp4';
import figmaLogo from '../../assets/logos/figma.png';
import canvaLogo from '../../assets/logos/canva.png';
import reactLogo from '../../assets/logos/react.png';
import cssLogo from '../../assets/logos/css.png';
import jsLogo from '../../assets/logos/JS.png';
import makeLogo from '../../assets/logos/make.png';

// Illustration pour la section Services Généraux
export const GeneralServicesIllustration = () => (
  <motion.div 
    key="grid"
    className="absolute inset-0 flex items-center justify-center"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.7, ease: "easeInOut" }}
  >
    <div className="relative h-[600px] w-[400px]">
      {/* Grille d'icônes */}
      <div className="grid grid-cols-3 gap-8 p-4">
        {/* Première rangée */}
        <div className="col-start-2">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <img src={reactLogo} alt="React" className="w-12 h-12" />
          </div>
        </div>
        <div className="col-start-1 row-start-2">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <FaJs className="text-[#F7DF1E] text-3xl" />
          </div>
        </div>
        <div className="col-start-3 row-start-2">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <FaHtml5 className="text-[#E34F26] text-3xl" />
          </div>
        </div>
        
        {/* Deuxième rangée */}
        <div className="col-start-1 row-start-3">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <FaCss3Alt className="text-[#1572B6] text-3xl" />
          </div>
        </div>
        <div className="col-start-2 row-start-3">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto bg-gradient-to-br from-blue-500 to-purple-500 shadow-md hover:shadow-lg transition-all">
            <SiTailwindcss className="text-white text-3xl" />
          </div>
        </div>
        <div className="col-start-3 row-start-3">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <FaVuejs className="text-[#4FC08D] text-3xl" />
          </div>
        </div>
        
        {/* Troisième rangée */}
        <div className="col-start-4 row-start-3">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <img src={figmaLogo} alt="Figma" className="w-10 h-10" />
          </div>
        </div>
        <div className="col-start-2 row-start-4">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto shadow-sm hover:shadow-md transition-all bg-white">
            <img src={canvaLogo} alt="Canva" className="w-10 h-10" />
          </div>
        </div>
        
        {/* Quatrième rangée - Technologies */}
        <div className="col-start-1 row-start-5">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto bg-white">
            <img src={jsLogo} alt="JavaScript" className="w-14 h-14" />
          </div>
        </div>
        <div className="col-start-3 row-start-5">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto bg-white">
            <img src={cssLogo} alt="CSS" className="w-12 h-12" />
          </div>
        </div>
        <div className="col-start-4 row-start-5">
          <div className="w-20 h-20 border border-gray-300 rounded-lg flex items-center justify-center mx-auto bg-white">
            <img src={makeLogo} alt="Make" className="w-12 h-12" />
          </div>
        </div>
      </div>
    </div>
  </motion.div>
);

// Illustration pour la section Sites Web
export const MobileAppIllustration = () => (
  <motion.div 
    key="website"
    className="absolute inset-0 flex items-center justify-center"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.7, ease: "easeInOut" }}
  >
    <div className="relative w-[400px] h-[400px] flex items-center justify-center">
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        className="w-full h-full object-contain"
      >
        <source src={websiteVideo} type="video/mp4" />
        Votre navigateur ne prend pas en charge les vidéos HTML5.
      </video>
    </div>
  </motion.div>
);

// Illustration pour la section Hébergement Web
export const WebHostingIllustration = () => (
  <motion.div 
    key="hosting"
    className="absolute inset-0 flex items-center justify-center"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.7, ease: "easeInOut" }}
  >
    <div className="relative w-[400px] h-[400px] flex items-center justify-center">
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        className="w-full h-full object-contain"
      >
        <source src={webHostingVideo} type="video/mp4" />
        Votre navigateur ne prend pas en charge les vidéos HTML5.
      </video>
    </div>
  </motion.div>
);

// Illustration pour la section Création de Logo
export const LogoDesignIllustration = () => (
  <motion.div 
    key="logo"
    className="absolute inset-0 flex items-center justify-center"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.7, ease: "easeInOut" }}
  >
    <div className="relative w-[400px] h-[400px] flex items-center justify-center">
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        className="w-full h-full object-contain"
      >
        <source src={logoDesignVideo} type="video/mp4" />
        Votre navigateur ne prend pas en charge les vidéos HTML5.
      </video>
    </div>
  </motion.div>
);

// Illustration pour la section Automatisation Make
export const MakeAutomationIllustration = () => (
  <motion.div 
    key="make"
    className="absolute inset-0 flex items-center justify-center"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.7, ease: "easeInOut" }}
  >
    <div className="relative w-[400px] h-[400px] flex items-center justify-center">
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        className="w-full h-full object-contain"
      >
        <source src={automationVideo} type="video/mp4" />
        Votre navigateur ne prend pas en charge les vidéos HTML5.
      </video>
    </div>
  </motion.div>
);

// Illustrations mobiles
export const MobileIllustrations = () => (
  <div className="md:hidden">
    <div className="py-12 px-4">
      <div className="py-12">
        {/* Hébergement web (mobile) */}
        <div className="relative mx-auto w-[240px] h-[240px] flex items-center justify-center">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full h-full object-contain"
          >
            <source src={webHostingVideo} type="video/mp4" />
            Votre navigateur ne prend pas en charge les vidéos HTML5.
          </video>
        </div>
      </div>

      <div className="py-12">
        {/* Site web (mobile) */}
        <div className="relative mx-auto w-[240px] h-[240px] flex items-center justify-center">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full h-full object-contain"
          >
            <source src={websiteVideo} type="video/mp4" />
            Votre navigateur ne prend pas en charge les vidéos HTML5.
          </video>
        </div>
      </div>

      <div className="py-12">
        {/* Création de logo (mobile) */}
        <div className="relative mx-auto w-[240px] h-[240px] flex items-center justify-center">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full h-full object-contain"
          >
            <source src={logoDesignVideo} type="video/mp4" />
            Votre navigateur ne prend pas en charge les vidéos HTML5.
          </video>
        </div>
      </div>

      <div className="py-12">
        {/* Automatisation Make (mobile) */}
        <div className="relative mx-auto w-[240px] h-[240px] flex items-center justify-center">
          <div className="w-48 h-48 bg-gradient-to-br from-teal-500 to-green-500 rounded-2xl shadow-xl flex items-center justify-center">
            <SiMakerbot size={60} className="text-white" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
